import React from "react";

import ChevronDown from "@uui/ChevronDown";

import { Button, ButtonProps, Menu as MuiMenu } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Stack, { Row, StackProps } from "@rui/Stack";

export const MenuButton = styled<React.FC<ButtonProps>>(
  ({ disabled, ...props }) => (
    <Button
      {...props}
      variant="outlined"
      endIcon={disabled ? undefined : <ChevronDown />}
    />
  )
)(({ disabled, startIcon, theme }) => ({
  borderColor: theme.palette.shades.neutral[100],
  padding: theme.spacing(1, 1.5, 1),
  paddingLeft: startIcon ? theme.spacing(1.5) : undefined,
  color: theme.palette.shades.neutral[500],
  pointerEvents: disabled ? "none" : undefined,
  "& .MuiButton-endIcon svg, .MuiButton-startIcon svg": {
    fontSize: "14px",
  },
  "& .MuiButton-startIcon svg": {
    color: theme.palette.shades.primary[500],
  },
  "&:hover": {
    borderColor: theme.palette.shades.neutral[100],
    backgroundColor: theme.palette.shades.ghost[300],
  },
}));

export const Menu = styled(MuiMenu)(({ theme }) => ({
  "& .MuiPaper-root": { padding: theme.spacing(1) },
}));

export const CompareWrapper = styled<React.FC<StackProps>>((props) => (
  <Row variant="apart" {...props} />
))(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(0, 1),
  marginTop: "10px",
}));

export const CustomPickerContainer = styled(Stack)({
  position: "absolute",
  bottom: 0,
  right: 0,
  zIndex: 100,
  "& .rs-picker": { visibility: "hidden" },
});
